import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SuperAdminService } from '../../../services/super-admin/super-admin.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// attach / detach permissions on a view. Detach is blocked by the backend when
// the pair is still referenced by a role or a user. data = { viewId, viewLabel }.
@Component({
  selector: 'app-sa-view-pairs-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './sa-view-pairs-dialog.component.html',
  styleUrls: ['./sa-view-pairs-dialog.component.scss', '../../../../common-style/dropdown.scss', '../../../../common-style/ac-dialog.scss'],
})
export class SaViewPairsDialogComponent implements OnInit {
  permissionId = new FormControl<number | null>(null);

  pairs: any[] = [];
  permissions: any[] = [];
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SaViewPairsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { viewId: number; viewLabel: string },
    private superAdminService: SuperAdminService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.loadPairs();
    this.superAdminService.listPermissions().subscribe({
      next: (res: any) => (this.permissions = res?.data?.permissions || []),
      error: () => {},
    });
  }

  loadPairs(): void {
    this.superAdminService.getViewPermissionPairs(this.data.viewId).subscribe({
      next: (res: any) => (this.pairs = res?.data?.pairs || res?.data?.viewPermissions || []),
      error: (err) => this.toastService.error(err?.error?.message || 'Failed to load permissions.'),
    });
  }

  attach(): void {
    if (!this.permissionId.value) {
      this.toastService.error('Select a permission.');
      return;
    }
    this.isLoading = true;
    this.superAdminService.attachPermission(this.data.viewId, this.permissionId.value).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Permission attached.');
        this.permissionId.setValue(null);
        this.isLoading = false;
        this.loadPairs();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to attach permission.');
      },
    });
  }

  detach(pair: any): void {
    this.isLoading = true;
    this.superAdminService.detachPermission(this.data.viewId, pair.svpId).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Permission detached.');
        this.isLoading = false;
        this.loadPairs();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to detach permission.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
